import { Accordion} from "lbh-frontend";
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-pro/css/all.css';
import { text } from "@fortawesome/fontawesome-svg-core";

//load the dotenv config in order to use the process.env variables
const regeneratorRuntime = require("regenerator-runtime");
const dotenv = require('dotenv').config();
const axios = require('axios').default;

//activate the start button
document.getElementById("start-button").onclick = function(){
  document.getElementById("location-search").hidden = false;
  document.getElementById("start-button").style.display = "none";
  window.scrollBy(0, 100);
};

// Create a variable for the postcode. 
let postcode = document.getElementById('postcode');
//Enter key listener that calls the GetAddressesviaPoxy function
postcode.addEventListener('keyup', (e) => {
  if (e.key == 'Enter'){
    GetAddressesViaProxy();
  }
});

//eventlistener for the button
document.getElementById("search").addEventListener("click", GetAddressesViaProxy);

//listener for the clear x in the input
postcode.addEventListener("search", (e) => {
  document.getElementById("error_message").innerHTML = "";
  document.getElementById("addresses").innerHTML = '';
  document.getElementById("address-details").innerHTML = "";
  //document.getElementById("show-results-button-div").innerHTML = "";
  document.getElementById("results").innerHTML = "";
});

function GetAddressesViaProxy() {
  document.getElementById("error_message").innerHTML = "";
  document.getElementById("addresses").innerHTML = '<p class="loading-text"> Loading addresses...</p>';
  document.getElementById("address-details").innerHTML = "";
  //document.getElementById("show-results-button-div").innerHTML = "";
  document.getElementById("results").innerHTML = "";
  document.getElementById("addresses").scrollIntoView({block: "nearest"});
  

  //Get the postcode value
  let address_input = document.getElementById("postcode").value;
  
  //test against postcode regex
  let postcode_regex = new RegExp("^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$");
  let isPostcode = postcode_regex.test(address_input);
  let results = null;
  
  if (! address_input){
    document.getElementById("error_message").innerHTML = "Please enter some text in the location search.";
  }
  else{
    //prepare query to send to the API, depending if we ave got a postcode or not
    let APIQueryString = '';
    if (isPostcode) {
      APIQueryString = `${process.env.ADDRESSES_API_PROXY_PROD}?format=detailed&usage_code=C,X,LP02&postcode=${address_input}`;
    }
    else {
      APIQueryString = `${process.env.ADDRESSES_API_PROXY_PROD}?format=detailed&usage_code=C,X,LP02&query=${address_input}`;
    }
    //First call to get the list of addresses from a postcode
    fetch(APIQueryString, {
      method: "get"
    })
    .then(response => response.json())
    .then(data => {
      //Get API error messages if the UPRN values are not right
      if (data.data.errors) {
        document.getElementById("error_message").innerHTML = response.data.errors[0].message;
        document.getElementById("addresses").innerHTML = '';
      //If there are no errors...
      } 
      else {
        results = data.data.data.address;
        //console.log(results);
        let pageCount = data.data.data.pageCount;
        //If there are no results, the postcode is not right. 
        if (results.length === 0) {
          document.getElementById("error_message").innerHTML = "No Hackney location found. Please amend your search.";
          document.getElementById("addresses").innerHTML = '';
          document.getElementById("address-details").innerHTML = '';
        }
        else {
          //If there are results from the addresses proxy, we list them. 
          //first, replace list element with a clone of itself, in order to remove previous listeners
          //let listElement = document.getElementById("addresses");
          document.getElementById("addresses").replaceWith(document.getElementById("addresses").cloneNode(true));
          //now fill the list
          document.getElementById("addresses").innerHTML = "<div class='govuk-form-group lbh-form-group'>"
            + "<select class='govuk-select govuk-!-width-full lbh-select' id='selectedAddress' name='selectedAddress'>";

          document.getElementById("selectedAddress").innerHTML = "<option disabled selected value> Select a location from the list </option>";
          for (let index = 0; index < results.length; ++index) {         
            //if (results[index].addressStatus == 'Approved' && (results[index].usagePrimary == 'Commercial' || results[index].usagePrimary == 'Dual Use')){
              if (results[index].commercialOccupier){
                document.getElementById("selectedAddress").innerHTML += "<option value='" + results[index].UPRN + "/" + results[index].singleLineAddress + "/" + results[index].usageDescription + "/" + results[index].ward + "'>" + results[index].commercialOccupier + " - " + results[index].singleLineAddress + "</option>";
              }else{
                document.getElementById("selectedAddress").innerHTML += "<option value='" + results[index].UPRN + "/" + results[index].singleLineAddress + "/" + results[index].usageDescription + "/" + results[index].ward + "'>" + results[index].singleLineAddress + "</option>";
              } 
            //}             
          }
 
          //load more pages of results if needed       
          if (pageCount > 1) {
            for (let pgindex = 2 ; pgindex<=pageCount ; ++pgindex){
              loadAddressAPIPageViaProxy(APIQueryString,address_input, pgindex);
            }
          }
          

          //close list of addresses
          document.getElementById("addresses").innerHTML += "</select></div>";

          //capture the change event - when an address is selected - we load the list of results using the UPRN selected. 
          document.getElementById("addresses").addEventListener('change', (event) => {
            //get the selected UPRN and address details from the list of addresses
            let selectedAddressDetails = document.querySelector('#selectedAddress').value.split('/');
            let selectedUPRN = selectedAddressDetails[0];

          loadRegisterInfo(selectedUPRN);
          document.getElementById("results").innerHTML = "";

          });  
          window.scrollBy(0,50);
        }
      }
    }).catch(error => {
      document.getElementById("error_message").innerHTML = "Sorry, an error occured while retrieving locations";
      document.getElementById("addresses").innerHTML = '';
    })
  }  
};

//function to add one page of results to the options list
function loadAddressAPIPageViaProxy(APIQueryString,address_input,pg) {
  let results = null;
  let full_address = null;
  let UPRN = null;
  fetch(APIQueryString+`&page=${pg}`, {
    method: "get"
  })
  .then(response => response.json())
  .then(data => {
    results = data.data.data.address;

    for (let index = 0; index < results.length; ++index) {      
      //if (results[index].addressStatus == 'Approved' && (results[index].usagePrimary == 'Commercial' || results[index].usagePrimary == 'Dual Use')){
        if (results[index].commercialOccupier){
          document.getElementById("selectedAddress").innerHTML += "<option value='" + results[index].UPRN + "/" + results[index].singleLineAddress + "/" + results[index].usageDescription + "/" + results[index].ward + "'>" + results[index].commercialOccupier + " - " + results[index].singleLineAddress + "</option>";
        }else{
          document.getElementById("selectedAddress").innerHTML += "<option value='" + results[index].UPRN + "/" + results[index].singleLineAddress + "/" + results[index].usageDescription + "/" + results[index].ward + "'>" + results[index].singleLineAddress + "</option>";
      } 
      //}
    }
  })
};


function loadRegisterInfo(selectedUPRN){
  //call to the table where we have all information
  axios.get(`${process.env.GEOSERVER_URL}?service=WFS&version=1.0.0&request=GetFeature&outputFormat=json&typeName=licensing_act_2003_premises&cql_filter=uprn='${selectedUPRN}'`)
    .then((res) => {
      //console.log(res.data);
      console.log(res.data.numberReturned)
      //If there isn't data, we get a error message
      if(res.data.numberReturned == 0){
          document.getElementById("results").innerHTML = '<span class="govuk-error-message lbh-error-message">No license found at this location. <br> Note: data is under review and will be added gradually.If you can&#39;t find the information you are looking for, please contact us at licensing@hackney.gov.uk.</span>';
      //If there is data...
      } else {
        if(res.data.numberReturned == 1){
        //If there only one license
        //message about loading
        document.getElementById('results').innerHTML = '<p class="loading-text"> Retrieving information...</p>'; 
        document.getElementById("results").scrollIntoView({block: "nearest"});
        
        console.log(res.data.features[0].properties);
        document.getElementById('results').innerHTML = "<h3>License details: </h3>";

        let textSection = "";

        //Add the common information table 
        //Premise name
        if (res.data.features[0].properties.premises_name){
        textSection += 
        `<dl class="govuk-summary-list lbh-summary-list">
          <div class="govuk-summary-list__row">
            <dt class="govuk-summary-list__key">Premises name</dt>
            <dd class="govuk-summary-list__value">${res.data.features[0].properties.premises_name}</dd>
          </div>`
        };

        //Premise address
        if (res.data.features[0].properties.premises_full_address){
        textSection += 
          `<div class="govuk-summary-list__row">
            <dt class="govuk-summary-list__key">Premises address</dt>
            <dd class="govuk-summary-list__value">${res.data.features[0].properties.premises_full_address}</dd>
          </div>`
        }

        //Ward
        if (res.data.features[0].properties.ward){
          textSection += 
            `<div class="govuk-summary-list__row">
              <dt class="govuk-summary-list__key">Ward</dt>
              <dd class="govuk-summary-list__value">${res.data.features[0].properties.ward}</dd>
            </div>`
          }
  

        //Licence number
        if (res.data.features[0].properties.licence_number){
        textSection += 
          `<div class="govuk-summary-list__row">
            <dt class="govuk-summary-list__key">Licence number</dt>
            <dd class="govuk-summary-list__value">${res.data.features[0].properties.licence_number}</dd>
          </div>`
        }

        //Premise licence holder
        if (res.data.features[0].properties.licence_holder_1_full_line){
          if (res.data.features[0].properties.licence_holder_2_full_line){
            if (res.data.features[0].properties.licence_holder_3_full_line){
              textSection += 
            `<div class="govuk-summary-list__row">
              <dt class="govuk-summary-list__key">Premises licence holders</dt>
                <dd class="govuk-summary-list__value">${res.data.features[0].properties.licence_holder_1_full_line}<br>${res.data.features[0].properties.licence_holder_2_full_line}<br>${res.data.features[0].properties.licence_holder_3_full_line}</dd>
              </dt>
            </div>`
               
            }else{
              textSection += 
            `<div class="govuk-summary-list__row">
              <dt class="govuk-summary-list__key">Premises licence holders</dt>
                <dd class="govuk-summary-list__value">${res.data.features[0].properties.licence_holder_1_full_line}<br>${res.data.features[0].properties.licence_holder_2_full_line}</dd>
              </dt>
            </div>`
            }

          } else {
            textSection += 
            `<div class="govuk-summary-list__row">
              <dt class="govuk-summary-list__key">Premises licence holder</dt>
                <dd class="govuk-summary-list__value">${res.data.features[0].properties.licence_holder_1_full_line}</dd>
              </dt>
            </div>`
          }
        }
        
        
        //Designated premises supervisor
        if (res.data.features[0].properties.designated_premises_supervisor){
        textSection += 
          `<div class="govuk-summary-list__row">
            <dt class="govuk-summary-list__key">Designated premises supervisor (DPS)</dt>
            <dd class="govuk-summary-list__value">${res.data.features[0].properties.designated_premises_supervisor}</dd>
          </div>`
        }

        //Date that the licence was granted
        if (res.data.features[0].properties.date_granted){
        textSection += 
          `<div class="govuk-summary-list__row">
            <dt class="govuk-summary-list__key">Date granted</dt>
            <dd class="govuk-summary-list__value">${res.data.features[0].properties.date_granted}</dd>
          </div>`
        }

        //Licence expiry date
        if (res.data.features[0].properties.licence_expiry_date){
        textSection += 
          `<div class="govuk-summary-list__row">
            <dt class="govuk-summary-list__key">Licence expiry date</dt>
            <dd class="govuk-summary-list__value">${res.data.features[0].properties.licence_expiry_date}</dd>
          </div>`
        }

        //Licence status
        if (res.data.features[0].properties.licence_status){
            //add style for the licence statuses - red/green
            if (res.data.features[0].properties.licence_status == 'Surrendered'|| res.data.features[0].properties.licence_status == 'Revoked' || res.data.features[0].properties.licence_status == 'Lapsed' || res.data.features[0].properties.licence_status == 'Deferred' || res.data.features[0].properties.licence_status == 'In Mediation'|| res.data.features[0].properties.licence_status == 'In-consultation'|| res.data.features[0].properties.licence_status == 'Invalid'|| res.data.features[0].properties.licence_status == 'Invalid code'|| res.data.features[0].properties.licence_status == 'Sub-Committee'|| res.data.features[0].properties.licence_status == 'Valid'|| res.data.features[0].properties.licence_status == 'Unknown/empty' || res.data.features[0].properties.licence_status == 'Lapsed' || res.data.features[0].properties.licence_status == 'Deferred' || res.data.features[0].properties.licence_status == 'In Mediation'|| res.data.features[0].properties.licence_status == 'In-consultation'|| res.data.features[0].properties.licence_status == 'Invalid'|| res.data.features[0].properties.licence_status == 'Invalid code'|| res.data.features[0].properties.licence_status == 'Sub-Committee'|| res.data.features[0].properties.licence_status == 'Valid'|| res.data.features[0].properties.licence_status == 'Suspended'){
              textSection += 
              `<div class="govuk-summary-list__row">
                <dt class="govuk-summary-list__key">Licence status</dt>
                <dd class="govuk-summary-list__value"><span class="govuk-tag lbh-tag lbh-tag--red"> ${res.data.features[0].properties.licence_status}</span>
                </dd>
                </div>
                </dl>
                </div>`; // Close the table
            } else{
              textSection += 
              `<div class="govuk-summary-list__row">
                <dt class="govuk-summary-list__key">Licence status</dt>
                <dd class="govuk-summary-list__value"><span class="govuk-tag lbh-tag lbh-tag--green"> ${res.data.features[0].properties.licence_status}</span>
                </dd>
                </div>
                </dl>
                </div>`; // Close the table
            }
        
        } else {
          `</dl>
        </div>`; //Close the table
        }


        if (res.data.features[0].properties.licence_status == 'Surrendered'|| res.data.features[0].properties.licence_status == 'Revoked' || res.data.features[0].properties.licence_status == 'Lapsed' || res.data.features[0].properties.licence_status == 'Deferred' || res.data.features[0].properties.licence_status == 'In Mediation'|| res.data.features[0].properties.licence_status == 'In-consultation'|| res.data.features[0].properties.licence_status == 'Invalid'|| res.data.features[0].properties.licence_status == 'Invalid code'|| res.data.features[0].properties.licence_status == 'Sub-Committee'|| res.data.features[0].properties.licence_status == 'Valid'|| res.data.features[0].properties.licence_status == 'Unknown/empty' || res.data.features[0].properties.licence_status == 'Lapsed' || res.data.features[0].properties.licence_status == 'Deferred' || res.data.features[0].properties.licence_status == 'In Mediation'|| res.data.features[0].properties.licence_status == 'In-consultation'|| res.data.features[0].properties.licence_status == 'Invalid'|| res.data.features[0].properties.licence_status == 'Invalid code'|| res.data.features[0].properties.licence_status == 'Sub-Committee'|| res.data.features[0].properties.licence_status == 'Valid'|| res.data.features[0].properties.licence_status == 'Suspended'){
          //List the results without the activities and the mandatory conditions
            document.getElementById('results').innerHTML = "<div id='default-example' data-attribute='value'>" + textSection + "</div>";
        } else {
            //Open the Activity types table
        textSection +=`<br><br>
        <table class="govuk-table lbh-table">
        <caption class="govuk-table__caption lbh-heading-h3 lbh-table__caption">
          The times the licence authorises the carrying out of licensable activities:
        </caption>
        <tbody class="govuk-table__body">`

        //Add the play activity
          if (res.data.features[0].properties.playstime1){
            if (res.data.features[0].properties.playstime2){
              if (res.data.features[0].properties.playstime3){
                textSection +=`
                <tr class="govuk-table__row" tabindex="0">
                  <th scope="row" class="govuk-table__header">Plays</th>
                  <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.playslocation1}<br>${res.data.features[0].properties.playstime1}</td>
                  <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.playslocation2}<br>${res.data.features[0].properties.playstime2}</td>
                </tr>`
              }else{
                textSection +=`
                <tr class="govuk-table__row" tabindex="0">
                  <th scope="row" class="govuk-table__header">Plays</th>
                  <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.playslocation1}<br>${res.data.features[0].properties.playstime1}</td>
                  <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.playslocation2}<br>${res.data.features[0].properties.playstime2}</td>
                  <td class="govuk-table__cell govuk-table__cell--numeric"></td>
                </tr>`
              }
  
            } else {
              textSection +=`
              <tr class="govuk-table__row" tabindex="0">
              <th scope="row" class="govuk-table__header">Plays</th>
                <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.playslocation1}<br>${res.data.features[0].properties.playstime1}</td>
                <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.playstime1}</td>
                <td class="govuk-table__cell govuk-table__cell--numeric"></td>
              </tr>`
            }
          }
        
        //Add the films activity
        if (res.data.features[0].properties.filmstime1){
          if (res.data.features[0].properties.filmstime2){
            if (res.data.features[0].properties.filmstime3){
              textSection +=`
              <tr class="govuk-table__row" tabindex="0">
              <th scope="row" class="govuk-table__header">Exhibition of films</th>
                <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.filmslocation1}<br>${res.data.features[0].properties.filmstime1}</td>
                <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.filmslocation2}<br>${res.data.features[0].properties.filmstime2}</td>
                <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.filmslocation3}<br>${res.data.features[0].properties.filmstime3}</td>
              </tr>`
            }else{
              textSection +=`
              <tr class="govuk-table__row" tabindex="0">
              <th scope="row" class="govuk-table__header">Exhibition of films</th>
                <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.filmslocation1}<br>${res.data.features[0].properties.filmstime1}</td>
                <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.filmslocation2}<br>${res.data.features[0].properties.filmstime2}</td>
                <td class="govuk-table__cell govuk-table__cell--numeric"></td>
              </tr>`
            }

          } else {
            textSection +=`
            <tr class="govuk-table__row" tabindex="0">
              <th scope="row" class="govuk-table__header">Exhibition of films</th>
              <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.filmslocation1}<br>${res.data.features[0].properties.filmstime1}</td>
              <td class="govuk-table__cell govuk-table__cell--numeric"></td>
              <td class="govuk-table__cell govuk-table__cell--numeric"></td>
            </tr>`
          }
        }

        //Add the indoor sporting activity
        if (res.data.features[0].properties.indoortime1){
          if (res.data.features[0].properties.indoortime2){
            if (res.data.features[0].properties.indoortime3){
              textSection +=`
              <tr class="govuk-table__row" tabindex="0">
                <th scope="row" class="govuk-table__header">Indoor sporting events</th>
                <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.sportslocation1}<br>${res.data.features[0].properties.indoortime1}</td>
                <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.sportslocation2}<br>${res.data.features[0].properties.indoortime2}</td>
                <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.sportslocation3}<br>${res.data.features[0].properties.indoortime3}</td>
              </tr>`
            }else{
              textSection +=`
              <tr class="govuk-table__row" tabindex="0">
                <th scope="row" class="govuk-table__header">Indoor sporting events</th>
                <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.sportslocation1}<br>${res.data.features[0].properties.indoortime1}</td>
                <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.sportslocation2}<br>${res.data.features[0].properties.indoortime2}</td>
                <td class="govuk-table__cell govuk-table__cell--numeric"></td>
              </tr>`
            }

          } else {
            textSection +=`
            <tr class="govuk-table__row" tabindex="0">
              <th scope="row" class="govuk-table__header">Indoor sporting events</th>
              <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.sportslocation1}<br>${res.data.features[0].properties.indoortime1}</td>
              <td class="govuk-table__cell govuk-table__cell--numeric"></td>
              <td class="govuk-table__cell govuk-table__cell--numeric"></td>
            </tr>`
          }
        }

        //Add the boxing activity
        if (res.data.features[0].properties.boxingtime1){
          if (res.data.features[0].properties.boxingtime2){
            if (res.data.features[0].properties.boxingtime3){
              textSection +=`
              <tr class="govuk-table__row" tabindex="0">
                <th scope="row" class="govuk-table__header">Boxing</th>
                <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.boxinglocation1}<br>${res.data.features[0].properties.boxingtime1}</td>
                <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.boxinglocation2}<br>${res.data.features[0].properties.livemusictime2}</td>
                <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.boxinglocation3}<br>${res.data.features[0].properties.boxingtime2}</td>
              </tr>`
            }else{
              textSection +=`
              <tr class="govuk-table__row" tabindex="0">
                <th scope="row" class="govuk-table__header">Boxing</th>
                <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.boxinglocation1}<br>${res.data.features[0].properties.boxingtime1}</td>
                <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.boxinglocation2}<br>${res.data.features[0].properties.livemusictime2}</td>
                <td class="govuk-table__cell govuk-table__cell--numeric"></td>
              </tr>`
            }

          } else {
            textSection +=`
            <tr class="govuk-table__row" tabindex="0">

              <th scope="row" class="govuk-table__header">Boxing</th>
              <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.boxinglocation1}<br>${res.data.features[0].properties.boxingtime1}</td>
              <td class="govuk-table__cell govuk-table__cell--numeric"></td>
              <td class="govuk-table__cell govuk-table__cell--numeric"></td>
            </tr>`
          }
        }
        //Add the live music activity
          if (res.data.features[0].properties.livemusictime1){
            if (res.data.features[0].properties.livemusictime2){
              if (res.data.features[0].properties.livemusictime3){
                textSection +=`
                <tr class="govuk-table__row" tabindex="0">
                <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.livemusiclocation1}<br>${res.data.features[0].properties.livemusictime1}</td>
                <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.livemusiclocation2}<br>${res.data.features[0].properties.livemusictime2}</td>
                <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.livemusiclocation3}<br>${res.data.features[0].properties.livemusictime3}</td>
                </tr>`
              }else{
                textSection +=`
                <tr class="govuk-table__row" tabindex="0">
                  <th scope="row" class="govuk-table__header">Live music</th>
                  <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.livemusiclocation1}<br>${res.data.features[0].properties.livemusictime1}</td>
                  <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.livemusiclocation2}<br>${res.data.features[0].properties.livemusictime2}</td>
                  <td class="govuk-table__cell govuk-table__cell--numeric"></td>
                </tr>`
              }

            } else {
              textSection +=`
              <tr class="govuk-table__row" tabindex="0">
                <th scope="row" class="govuk-table__header">Live music</th>
                <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.livemusiclocation1}<br>${res.data.features[0].properties.livemusictime1}</td>
                <td class="govuk-table__cell govuk-table__cell--numeric"></td>
                <td class="govuk-table__cell govuk-table__cell--numeric"></td>
              </tr>`
            }
          }

          //Add the recorded music activity
           if (res.data.features[0].properties.recordemusictime1){
              if (res.data.features[0].properties.recordemusictime2){
                if (res.data.features[0].properties.recordemusictime3){
                  textSection +=`
                  <tr class="govuk-table__row" tabindex="0">
                    <th scope="row" class="govuk-table__header">Recorded music</th>
                    <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.recordedlocation1}<br>${res.data.features[0].properties.recordemusictime1}</td>
                    <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.recordedlocation2}<br>${res.data.features[0].properties.recordemusictime2}</td>
                    <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.recordedlocation3}<br>${res.data.features[0].properties.recordemusictime3}</td>
                  </tr>`
                }else{
                  textSection +=`
                  <tr class="govuk-table__row" tabindex="0">
                    <th scope="row" class="govuk-table__header">Recorded music</th>
                    <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.recordedlocation1}<br>${res.data.features[0].properties.recordemusictime1}</td>
                    <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.recordedlocation2}<br>${res.data.features[0].properties.recordemusictime2}</td>
                    <td class="govuk-table__cell govuk-table__cell--numeric"></td>
                  </tr>`
                }

              } else {
                textSection +=`
                <tr class="govuk-table__row" tabindex="0">
                  <th scope="row" class="govuk-table__header">Recorded music</th>
                  <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.recordedlocation1}<br>${res.data.features[0].properties.recordemusictime1}</td>
                  <td class="govuk-table__cell govuk-table__cell--numeric"></td>
                  <td class="govuk-table__cell govuk-table__cell--numeric"></td>
                </tr>`
              }
            }

            //Add the performance of dance activity
              if (res.data.features[0].properties.dancetime1){
                if (res.data.features[0].properties.dancetime2){
                  if (res.data.features[0].properties.dancetime3){
                    textSection +=`
                    <tr class="govuk-table__row" tabindex="0">
                      <th scope="row" class="govuk-table__header">Performances of dance</th>
                      <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.perf_dance_location1}<br>${res.data.features[0].properties.dancetime1}</td>
                      <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.perf_dance_location2}<br>${res.data.features[0].properties.dancetime2}</td>
                      <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.perf_dance_location3}<br>${res.data.features[0].properties.dancetime3}</td>
                    </tr>`
                  }else{
                    textSection +=`
                    <tr class="govuk-table__row" tabindex="0">
                      <th scope="row" class="govuk-table__header">Performances of dance</th>
                      <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.perf_dance_location1}<br>${res.data.features[0].properties.dancetime1}</td>
                      <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.perf_dance_location2}<br>${res.data.features[0].properties.dancetime2}</td>
                      <td class="govuk-table__cell govuk-table__cell--numeric"></td>
                    </tr>`
                  }
    
                } else {
                  textSection +=`
                  <tr class="govuk-table__row" tabindex="0">
                    <th scope="row" class="govuk-table__header">Performances of dance</th>
                    <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.perf_dance_location1}<br>${res.data.features[0].properties.dancetime1}</td>
                    <td class="govuk-table__cell govuk-table__cell--numeric"></td>
                    <td class="govuk-table__cell govuk-table__cell--numeric"></td>
                  </tr>`
                }
              }

          //Add the other entertaiment activity
            if (res.data.features[0].properties.other_enter_time1){
              if (res.data.features[0].properties.other_enter_time2){
                if (res.data.features[0].properties.other_enter_time3){
                  textSection +=`
                  <tr class="govuk-table__row" tabindex="0">
                  <th scope="row" class="govuk-table__header">Entertainment of a similar description to live music recorded music and performances of dance</th>
                  <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.other_enter_location1}<br>${res.data.features[0].properties.other_enter_time1}</td>
                  <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.other_enter_location2}<br>${res.data.features[0].properties.other_enter_time2}</td>
                  <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.other_enter_location3}<br>${res.data.features[0].properties.other_enter_time3}</td>
                  </tr>`
                }else{
                  textSection +=`
                  <tr class="govuk-table__row" tabindex="0">
                    <th scope="row" class="govuk-table__header">Entertainment of a similar description to live music recorded music and performances of dance</th>
                    <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.other_enter_location1}<br>${res.data.features[0].properties.other_enter_time1}</td>
                    <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.other_enter_location2}<br>${res.data.features[0].properties.other_enter_time2}</td>
                    <td class="govuk-table__cell govuk-table__cell--numeric"></td>
                  </tr>`
                }
  
              } else {
                textSection +=`
                <tr class="govuk-table__row" tabindex="0">
                  <th scope="row" class="govuk-table__header">Entertainment of a similar description to live music recorded music and performances of dance</th>
                  <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.other_enter_location1}<br>${res.data.features[0].properties.other_enter_time1}</td>
                  <td class="govuk-table__cell govuk-table__cell--numeric"></td>
                  <td class="govuk-table__cell govuk-table__cell--numeric"></td>
                </tr>`
              }
            }

            //Add the late night refreshment activity
              if (res.data.features[0].properties.latenighttime1){
                if (res.data.features[0].properties.latenighttime2){
                  if (res.data.features[0].properties.latenighttime3){
                    textSection +=`
                    <tr class="govuk-table__row" tabindex="0">
                    <th scope="row" class="govuk-table__header">Late night refreshment</th>
                    <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.latenightlocation1}<br>${res.data.features[0].properties.latenighttime1}</td>
                    <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.latenightlocation2}<br>${res.data.features[0].properties.latenighttime2}</td>
                    <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.latenightlocation3}<br>${res.data.features[0].properties.latenighttime3}</td>
                    </tr>`
                  }else{
                    textSection +=`
                    <tr class="govuk-table__row" tabindex="0">
                    <th scope="row" class="govuk-table__header">Late night refreshment</th>
                    <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.latenightlocation1}<br>${res.data.features[0].properties.latenighttime1}</td>
                    <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.latenightlocation2}<br>${res.data.features[0].properties.latenighttime2}</td>
                      <td class="govuk-table__cell govuk-table__cell--numeric"></td>
                    </tr>`
                  }
    
                } else {
                  textSection +=`
                  <tr class="govuk-table__row" tabindex="0">
                    <th scope="row" class="govuk-table__header">Late night refreshment</th>
                    <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.latenightlocation1}<br>${res.data.features[0].properties.latenighttime1}</td>
                    <td class="govuk-table__cell govuk-table__cell--numeric"></td>
                    <td class="govuk-table__cell govuk-table__cell--numeric"></td>
                  </tr>`
                }
              }

              //Add the supply of alcohol activity
                if (res.data.features[0].properties.alcoholtimes1){
                  if (res.data.features[0].properties.alcoholtimes2){
                    if (res.data.features[0].properties.alcoholtimes3){
                      textSection +=`
                      <tr class="govuk-table__row" tabindex="0">
                        <th scope="row" class="govuk-table__header">Supply of alcohol<br>(${res.data.features[0].properties.alcoholsaletype})</th>
                        <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.alcohollocation1}<br>${res.data.features[0].properties.alcoholtimes1}</td>
                        <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.alcohollocation2}<br>${res.data.features[0].properties.alcoholtimes2}</td>
                        <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.alcohollocation3}<br>${res.data.features[0].properties.alcoholtimes3}</td>
                      </tr>`
                    }else{
                      textSection +=`
                      <tr class="govuk-table__row" tabindex="0">
                      <th scope="row" class="govuk-table__header">Supply of alcohol<br>(${res.data.features[0].properties.alcoholsaletype})</th>
                      <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.alcohollocation1}<br>${res.data.features[0].properties.alcoholtimes1}</td>
                      <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.alcohollocation2}<br>${res.data.features[0].properties.alcoholtimes2}</td>
                        <td class="govuk-table__cell govuk-table__cell--numeric"></td>
                      </tr>`
                    }
      
                  } else {
                    textSection +=`
                    <tr class="govuk-table__row" tabindex="0">
                    <th scope="row" class="govuk-table__header">Supply of alcohol<br>(${res.data.features[0].properties.alcoholsaletype})</th>
                    <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.alcohollocation1}<br>${res.data.features[0].properties.alcoholtimes1}</td>
                    <td class="govuk-table__cell govuk-table__cell--numeric"></td>
                      <td class="govuk-table__cell govuk-table__cell--numeric"></td>
                    </tr>`
                  }
                }
                 //Add the opening times
                 if (res.data.features[0].properties.openinghourstimes1){
                  if (res.data.features[0].properties.openinghourstimes2){
                    if (res.data.features[0].properties.openinghourstimes3){
                      textSection +=`
                      <tr class="govuk-table__row" tabindex="0">
                        <th scope="row" class="govuk-table__header">Opening times</th>
                        <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.openinghourstimes1}</td>
                        <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.openinghourstimes2}</td>
                        <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.openinghourstimes3}</td>
                      </tr>`
                    }else{
                      textSection +=`
                      <tr class="govuk-table__row" tabindex="0">
                      <th scope="row" class="govuk-table__header">Opening times</th>
                        <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.openinghourstimes1}</td>
                        <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.openinghourstimes2}</td>
                        <td class="govuk-table__cell govuk-table__cell--numeric"></td>
                      </tr>`
                    }
      
                  } else {
                    textSection +=`
                    <tr class="govuk-table__row" tabindex="0">
                      <th scope="row" class="govuk-table__header">Opening times</th>
                      <td class="govuk-table__cell govuk-table__cell--numeric">${res.data.features[0].properties.openinghourstimes1}</td>
                      <td class="govuk-table__cell govuk-table__cell--numeric"></td>
                      <td class="govuk-table__cell govuk-table__cell--numeric"></td>
                    </tr>`
                  }
   
        //Close the Activity types table
        textSection +=`</tbody>
        </table>`


      //Create the conditions text for each accordion section
      let mandatoryConditionsText ="";
      if (res.data.features[0].properties.mandatory_cond_alcohol_supply){
      mandatoryConditionsText += `
      <h4>Supply of alcohol</h4><br>${res.data.features[0].properties.mandatory_cond_alcohol_supply}<br><br>`
      }
      if (res.data.features[0].properties.mandatory_cond_film_exhibition){
        mandatoryConditionsText += `
        <h4>Film exhibition</h4><br>${res.data.features[0].properties.mandatory_cond_film_exhibition}<br><br>`
      }
      if (res.data.features[0].properties.mandatory_cond_door_supervision){
        mandatoryConditionsText += `
        <h4>Door supervision</h4><br>${res.data.features[0].properties.mandatory_cond_door_supervision}<br><br>`
      }

      let annex2ConditionsText ="";
      if (res.data.features[0].properties.opening_schedule){
        annex2ConditionsText += `
        <h4>Conditions consistent with the Operating Schedule</h4><br>${res.data.features[0].properties.opening_schedule}<br><br>`
        }
      if (res.data.features[0].properties.responsible_authority){
        annex2ConditionsText += `
        <h4>Conditions derived from Responsible Authority representations</h4><br>${res.data.features[0].properties.responsible_authority}<br><br>`
      }

      let annex3ConditionsText ="";
      if (res.data.features[0].properties.committee_hearing){
        annex3ConditionsText += `
        <h4>Conditions attached after a hearing by the licensing authority</h4><br>${res.data.features[0].properties.committee_hearing}<br><br>`
        }

      //Add the accordion sections to the rest of the text
      textSection +=`<br><br>
      <h3 class="govuk-table__caption lbh-heading-h3 lbh-table__caption">
      Conditions</h3>
      <div class='govuk-accordion myClass lbh-accordion' data-module='govuk-accordion' id='default-example' data-attribute='value'>
        <div class='govuk-accordion__section'>
          <div class='govuk-accordion__section-header'>
            <h5 class='govuk-accordion__section-heading'>
            <span class='govuk-accordion__section-button' id='default-example-heading-1'> 
              Mandatory Conditions
            </span></h5>
          </div>
        <div id='default-example-content-1' class='govuk-accordion__section-content' aria-labelledby='default-example-heading-1'>
          <p>${mandatoryConditionsText}</p>
        </div>`

        if (annex2ConditionsText){
          textSection +=`<div class='govuk-accordion__section'>
          <div class='govuk-accordion__section-header'>
            <h5 class='govuk-accordion__section-heading'>
            <span class='govuk-accordion__section-button' id='default-example-heading-1'> 
              Annex 2
            </span></h5>
          </div>
        <div id='default-example-content-1' class='govuk-accordion__section-content' aria-labelledby='default-example-heading-1'>
          <p>${annex2ConditionsText}</p>
        </div>`
        }

        if (annex3ConditionsText){
          textSection += `<div class='govuk-accordion__section'>
          <div class='govuk-accordion__section-header'>
            <h5 class='govuk-accordion__section-heading'>
            <span class='govuk-accordion__section-button' id='default-example-heading-1'> 
              Annex 3
            </span></h5>
          </div>
        <div id='default-example-content-1' class='govuk-accordion__section-content' aria-labelledby='default-example-heading-1'>
          <p>${annex3ConditionsText}</p>
        </div>`
        }

        textSection += `</div>`//Close the div
    }

      //List the results using an accordion. 
      document.getElementById('results').innerHTML = "<div id='default-example' data-attribute='value'>" + textSection + "</div>";
     
      
        }
        } else{
          //When there is more than one license
          //console.log('There is more than one licenses');
          //console.log(res.data.features);
          document.getElementById("results").innerHTML = '<span class="govuk-error-message lbh-error-message">There are multiple licenses associated to this address. Please contact us at licensing@hackney.gov.uk.</span>';
        }//Close else(when numberReturned is not 1)
      }//Close else (when numberReturned is not 0)
       
      
      //Activate the JS of the component
       const accordion = document.querySelector('[data-module="govuk-accordion"]');
       if (accordion) {
         new Accordion(accordion).init();
       }
      
      
    }) //Close then
    .catch((error) => {
      //Catch geoserver error
      document.getElementById("error_message").innerHTML = 'Sorry, there was a problem retrieving the results for this address.';
    })  
}

